import { SunrunWorkOrderStatus } from "@remi/types/workOrderStatus";

export const SCHEDULABLE_WORK_ORDER_STATUSES = [
  SunrunWorkOrderStatus["Ready to Schedule"],
  SunrunWorkOrderStatus["HIC Sold; Pending Scheduling"],
] as const satisfies readonly SunrunWorkOrderStatus[];

// Chosen mitigation window for Sunrun photo indexing, not a Sunrun-published SLA.
export const WO_ONLY_INVOICE_SUBMIT_DELAY_HOURS = 24;

// Bounds how many carrier-decision photos are embedded in one contractor work-order PDF, keeping
// its render time and attachment size in check; also the uploader's client-side maxFiles.
export const MAX_WORK_ORDER_PHOTOS = 30;

// Also printed as the on-site contact on contractor work-order PDFs, so it must stay a staffed line.
export const CHANGE_ORDER_PHONE_NUMBER = "+13852591894";

export const WO_EXPIRY_REASON = "Time expired";

export const MAX_STALLED_WO_TASKS_PER_RUN = 100;

// The original contractor is legally owed 10 business days to accept a corrections work order before
// it can be pulled. Expiry counts 10 hours (8am–6pm Mountain) per weekday; holidays are not skipped.
export const CORRECTIONS_ORIGINAL_CONTRACTOR_EXPIRY_BUSINESS_HOURS = 100;

// $5,000: Finance's ceiling for a single work order concession.
export const MAX_WORK_ORDER_CONCESSION_CENTS = 500_000;

// $500: an Ops-approved concession at or under this applies without waiting on Finance.
export const CONCESSION_AUTO_APPROVE_MAX_CENTS = 50_000;

export const WORK_ORDER_REJECTION_REVIEW_CLAIMED = "Work order rejection review in progress";

// Long enough to outlast a slow reject-and-reassign (reset + evaluation), short enough that a crashed
// run's claim does not strand the review for a working day.
export const WORK_ORDER_REJECTION_REVIEW_CLAIM_STALE_MS = 10 * 60 * 1000;
